import { useState } from 'react';
import { Link } from 'react-router-dom';
import { SHARED_META, STORY_ROW } from '../../constants/share.constants';
import type { CircleStoryFieldsFragment } from '../../gql/graphql';
import { formatDate } from '../../helpers/dateConverters';

interface CircleStoryRowProps {
  story: CircleStoryFieldsFragment;
  totalMembers: number;
}

const CircleStoryRow = ({ story, totalMembers }: CircleStoryRowProps) => {
  const [expanded, setExpanded] = useState(false);
  const readCount = story.readBy?.length ?? 0;

  return (
    <div className="circle-story-row">
      <Link to={`/post/${story.storyId}`} className="circle-story-row__title">
        {story.title}
      </Link>
      <p className="circle-story-row__meta">
        {SHARED_META.SHARED_BY}
        {story.sharedBy} · {formatDate(story.sharedAt)}
      </p>

      {readCount === 0 ? (
        <p className="circle-story-row__no-reads">{STORY_ROW.NO_READS}</p>
      ) : (
        <div className="circle-story-row__receipts">
          <span>
            {STORY_ROW.READ_BY} {readCount} {STORY_ROW.OF} {totalMembers}{' '}
            {STORY_ROW.MEMBERS}
          </span>{' '}
          <button
            type="button"
            className="circle-story-row__receipts-toggle"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? STORY_ROW.HIDE : STORY_ROW.SHOW}
          </button>
          {expanded && (
            <div className="circle-story-row__receipts-list">
              {story.readBy?.map((receipt) => (
                <p key={receipt.username}>
                  @{receipt.username} — {formatDate(receipt.readAt)}
                </p>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CircleStoryRow;
